export const useComponentProps = (component, propName) => {
  return {
    computed: {
      [`${propName}`](){
        let keys = Object.keys(component.props)
        let props = {}
        keys.forEach(key => {
          let prop = this.$props[key]
          if(prop != undefined)
            props[key] = this.$props[key]
        })
        return props
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/utils/use/props.js